import { Link } from '@chakra-ui/react';
import { ColumnDef } from '@tanstack/react-table';

import { dateUtils } from 'shared_DEPRECATED/utils';

import { Resource } from 'features/resourceBank/types';

export const resourceBankTableColumnsData: ColumnDef<Resource>[] = [
  {
    header: 'Title',
    size: 600,
    cell: ({ row }) => {
      const { title, url } = row.original;

      return (
        <Link
          color="var(--bgCompAccent)"
          fontWeight="medium"
          href={row.original.url}
          target="_blank"
        >
          {title || url}
        </Link>
      );
    },
  },
  {
    header: 'Shared at',
    accessorKey: 'createdAt',
    cell: ({ row }) => (
      <span>{dateUtils(row.getValue('createdAt')).format('D MMM, YYYY')}</span>
    ),
  },
  {
    header: 'Kind',
    accessorKey: 'kind',
  },
  {
    header: 'Last shared by',
    accessorKey: 'sharedByName',
  },
];
